function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.0259 7.51684L12.2843 7.40451L12.1565 8.24858L13.01 8.26667L13.0259 7.51684ZM13.0259 7.51684C13.01 8.26667 13.0102 8.26667 13.0103 8.26667L13.0108 8.26668L13.0118 8.2667L13.0146 8.26676L13.0232 8.26689L13.0521 8.26718C13.0764 8.26734 13.1106 8.26738 13.1537 8.26698C13.2399 8.26617 13.362 8.26356 13.512 8.2565C13.811 8.24242 14.2254 8.21041 14.6883 8.13815C15.5812 7.99874 16.7897 7.69025 17.6474 6.95346C18.7623 5.99582 19.1144 4.2944 18.1597 3.12972C17.1927 1.94987 15.4643 2.01582 14.3441 2.97803C13.4889 3.71263 12.9851 4.87165 12.6974 5.74324C12.5482 6.19537 12.4458 6.60588 12.3807 6.90355C12.348 7.05284 12.3244 7.17493 12.3087 7.26112C12.3009 7.30425 12.2951 7.33847 12.291 7.36271L12.2864 7.39148L12.285 7.40001L12.2846 7.40277L12.2845 7.40377L12.2844 7.40417C12.2844 7.40435 12.2843 7.40451 13.0259 7.51684Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6428 7.51684L10.6587 8.26667L11.5122 8.24858L11.3843 7.40451L10.6428 7.51684ZM10.6428 7.51684C11.3843 7.40451 11.3843 7.40435 11.3843 7.40417L11.3842 7.40377L11.3841 7.40277L11.3837 7.40001L11.3823 7.39148L11.3776 7.36271C11.3736 7.33847 11.3678 7.30425 11.3599 7.26112C11.3443 7.17493 11.3207 7.05284 11.288 6.90355C11.2228 6.60588 11.1205 6.19537 10.9713 5.74324C10.6836 4.87165 10.1798 3.71263 9.32456 2.97803C8.20438 2.01582 6.47602 1.94987 5.50893 3.12972C4.55427 4.2944 4.90641 5.99582 6.02127 6.95346C6.87902 7.69025 8.08746 7.99874 8.98042 8.13815C9.44328 8.21041 9.8577 8.24242 10.1567 8.2565C10.3066 8.26356 10.4288 8.26617 10.515 8.26698C10.5581 8.26738 10.5923 8.26734 10.6166 8.26718L10.6454 8.26689L10.6541 8.26676L10.6569 8.2667L10.6579 8.26668L10.6583 8.26667C10.6585 8.26667 10.6587 8.26667 10.6428 7.51684Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.21539,
  y: 8.21283,
  width: 19.5692,
  height: 4.47522,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.71826 13.2693V21.551H20.2817V13.2693",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8344 8.7972V21.7167",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgPresent = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPresent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Present.e733448c.svg";
export { ForwardRef as ReactComponent };